
import BaseBlock from '@headlines/utils/BaseBlock';
import ContentFragment from '@core/components/ContentFragment.vue';
import BlockTypeSettings from '@headlines/types/block/111-120/blockType116';
import { HeadlineWithRelatedArticles } from '@headlines/types/headline';

const defaultSettings = {};

interface LocalData {
  items: HeadlineWithRelatedArticles[];
  groups: {
    name: string;
    title: string;
    items: HeadlineWithRelatedArticles[];
  }[];
  content?: any;
  html?: string;
  htmlLeft?: string;
  htmlRight?: string;
  attrs: {
    code?: string;
    codeLeft?: string;
    codeRight?: string;
  };
}

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({
  components: {
    ContentFragment,
  },
  data() {
    return {
      idLeft: Math.floor(10000 + Math.random() * 90000),
      idRight: Math.floor(10000 + Math.random() * 90000),
      localData: this.data as LocalData,
    };
  },
  computed: {
    dataLeft() {
      return {
        ...this.localData,
        html: this.localData.htmlLeft,
        attrs: {
          ...this.localData.attrs,
          code: this.localData.attrs.codeLeft,
        },
      };
    },
    dataRight() {
      return {
        ...this.localData,
        html: this.localData.htmlRight,
        attrs: {
          ...this.localData.attrs,
          code: this.localData.attrs.codeRight,
        },
      };
    },
  },
});
